import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorIsAccountInternational = (account: IAccount) => {
  return (
    (account.country ? account.country !== "US" : false) &&
    account.status !== AccountStatus.Inactive
  );
};
